// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__MLAccountSummary__alertGroupComponent{margin-bottom:20px;padding:unset}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-gateway-react/Accounts/MLAccountSummary/MLAccountSummary.module.scss"],"names":[],"mappings":"AAAA,4CAEI,kBAAA,CADA,aACA","sourcesContent":[".alertGroupComponent {\n    padding: unset;\n    margin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alertGroupComponent": "app__MLAccountSummary__alertGroupComponent"
};
export default ___CSS_LOADER_EXPORT___;
